import React from "react";
import { Redirect, Switch } from "react-router-dom";
import { ContentRoute } from "../../../_metronic/layout/components/content/ContentRoute";
import WaitForSettlement from "../sale/waitForSettlement/waitForSettlement";
import WaitForSettlementByCustomer from "../sale/waitForSettlement/waitForSettlementByCustomer";

export default function FinancialConfigPage() {
  return (
    <Switch>
      {
        <Redirect
          exact={true}
          from="/financial"
          to="/financial/WaitForSettlement"
        />
      }
      <ContentRoute
        path="/financial/WaitForSettlement"
        component={WaitForSettlement}
        label={undefined}
        children={undefined}
        render={undefined}
      />
      <ContentRoute
        path="/financial/WaitForSettlementByCustomer"
        component={WaitForSettlementByCustomer}
        label={undefined}
        children={undefined}
        render={undefined}
      />
    </Switch>
  );
}
